import styled from 'styled-components';
const TableData = styled.td `
	${p => p.$width &&
    `width:${p.$width} !important; 
		min-width: ${p.$width} !important; 
		max-width: ${p.$width} !important;`};
	${p => p.$align && `text-align: ${p.$align} !important`};
`;
export default TableData;
